export default class RaceNav {
  constructor() {
    this.hero = document.querySelector(".race-hero")
    this.heroDate = document.querySelector(".race-hero .race-hero__date--desktop")
    this.nav = document.querySelector(".race-nav")
    this.content = document.querySelector(".race-content")
    this.menuButton = document.querySelector(".race-nav button")
    this.topImage = document.querySelector(".race-hero__image-top")

    if (this.heroDate && this.nav) {
      this.navDate = this.nav.querySelector(".race-hero__date")
      this.navLinks = this.nav.querySelectorAll("a")
      this.init()
    }
  }

  init() {
    window.addEventListener("scroll", () => {
      this.handleScroll()
    })

    window.addEventListener("resize", () => {
      this.handleScroll()
    })

    document.addEventListener("DOMContentLoaded", () => {
      this.handleScroll()
    })

    const menu = $(this.menuButton.nextElementSibling)

    this.menuButton.addEventListener("click", () => {
      this.menuButton.classList.toggle("open")
      menu.slideToggle(200)
    })

    this.navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        this.menuButton.classList.remove("open")
        menu.slideUp(200)
      })
    })
  }

  handleScroll() {
    const heroDateRect = this.heroDate.getBoundingClientRect()
    const navRect = this.nav.getBoundingClientRect()
    const anchors = this.content.querySelectorAll("a[name]")
    const windowWidth = window.innerWidth

    let navHeight = this.nav.clientHeight
    this.updateActiveNavLinks(anchors, navHeight)

    if (windowWidth < 960) {
      this.navDate.style.display = "none"
      this.heroDate.style.visibility = "visible"
      this.nav.classList.remove("fixed")

      return
    }

    if (this.navDate) {
      navHeight = navHeight - this.navDate.clientHeight

      if (navRect.top <= heroDateRect.bottom) {
        this.navDate.style.display = "flex"
        this.heroDate.style.visibility = "hidden"
      } else {
        this.navDate.style.display = "none"
        this.heroDate.style.visibility = "visible"
      }
    }

    if (this.content.getBoundingClientRect().top + navHeight / 2 < window.innerHeight / 2) {
      this.nav.classList.add("fixed")

      if (this.navDate) {
        this.nav.classList.add("fixed--with-date")
      }
    } else {
      this.nav.classList.remove("fixed")
      this.nav.classList.remove("fixed--with-date")
    }
  }

  updateActiveNavLinks(anchors, navHeight) {
    const scrollPosition = window.scrollY + navHeight + 100
    let activeAnchor = null
    anchors.forEach((anchor) => {
      const anchorTop = anchor.offsetTop
      const anchorBottom = anchorTop + (anchor.offsetHeight || 0)

      if (scrollPosition >= anchorTop && scrollPosition < anchorBottom) {
        activeAnchor = anchor
      }
    })

    if (!activeAnchor) {
      let closestAnchor = null
      let closestDistance = Infinity

      anchors.forEach((anchor) => {
        const anchorTop = anchor.offsetTop
        if (anchorTop <= scrollPosition) {
          const distance = scrollPosition - anchorTop
          if (distance < closestDistance) {
            closestDistance = distance
            closestAnchor = anchor
          }
        }
      })

      activeAnchor = closestAnchor
    }

    this.navLinks.forEach((link) => {
      link.classList.remove("active")

      if (activeAnchor) {
        const linkHref = link.getAttribute("href")
        const anchorName = activeAnchor.getAttribute("name")

        if (linkHref && anchorName && linkHref.includes(`#${anchorName}`)) {
          link.classList.add("active")
        }
      }
    })
  }
}
